var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Users"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.25004 15C10.9424 15 13.125 12.8174 13.125 10.125C13.125 7.43261 10.9424 5.25 8.25004 5.25C5.55765 5.25 3.37504 7.43261 3.37504 10.125C3.37504 12.8174 5.55765 15 8.25004 15Z",
    stroke: "#564FFD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.5699 5.43271C15.2404 5.24379 15.9436 5.20075 16.6322 5.3065C17.3207 5.41224 17.9786 5.66431 18.5615 6.04572C19.1445 6.42714 19.6389 6.92904 20.0115 7.51763C20.3841 8.10622 20.6263 8.76783 20.7217 9.45789C20.8171 10.148 20.7635 10.8504 20.5646 11.5181C20.3656 12.1857 20.0259 12.8029 19.5683 13.3281C19.1107 13.8534 18.5459 14.2745 17.9118 14.5631C17.2778 14.8517 16.5893 15.001 15.8926 15.0011",
    stroke: "#564FFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.49952 18.5059C2.26089 17.4229 3.27166 16.539 4.4465 15.9288C5.62134 15.3186 6.92574 15.0001 8.24959 15C9.57345 14.9999 10.8779 15.3184 12.0528 15.9285C13.2276 16.5386 14.2385 17.4225 14.9999 18.5054",
    stroke: "#564FFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.8927 15C17.2166 14.999 18.5213 15.3171 19.6963 15.9273C20.8713 16.5375 21.8819 17.4218 22.6427 18.5054",
    stroke: "#564FFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.e343dc18b76cea582c15ededfebcc213.svg";
export { ForwardRef as ReactComponent };